import api from './api';

export const transcriptAudio = async (file: File) => {
  const formData: FormData = new FormData();
  formData.append('file', file, 'audio.wav');
  return await api.post(`/transcript/`, formData);
};
